/* Centauri C30 video rescue (QA F03).
   The storefront delay-JS optimizer strips the src attribute off any iframe
   the moment it enters the live DOM (moves it to data-src) and never restores
   it, so the YouTube embed the shared kik-ugc-videos.js clones out of
   <kik-deferred-media><template> comes up as about:blank — the card turns
   into a grey void on click.

   Reuse-or-add rule: the shared kik-ugc-videos.js is used by other pages and
   must not be modified, so this NEW centauri-only companion rides along on the
   c30 roots. A capture-phase listener stashes the embed URL from the inert
   <template> BEFORE the shared handler clones it, then navigates the stripped
   iframe through contentWindow.location.replace() — navigation never touches
   the src attribute, which is the only thing the optimizer intercepts.

   Success detection: a src-less clone fires a load event for about:blank right
   after insert, so load listeners are useless. Once the embed actually
   navigates it becomes cross-origin and reading its location throws — that
   throw is the one dependable "navigated" probe (verified in headless Chromium
   against the live optimizer).

   Idempotent, multi-instance safe, Theme-Editor safe; file name matches the
   centauri-script-rescue ALLOW list so the optimizer cannot keep it delayed. */
(function () {
  'use strict';

  if (window.__centauriC30VideoRescue) {
    window.__centauriC30VideoRescue.init(document);
    return;
  }

  function withAutoplay(url) {
    if (url.indexOf('autoplay=0') !== -1) return url.replace('autoplay=0', 'autoplay=1');
    if (url.indexOf('autoplay=1') !== -1) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
  }

  function navigated(iframe) {
    var w = iframe.contentWindow;
    if (!w) return false;
    try { void w.location.href; return false; } catch (e) { return true; }
  }

  function navigateIframe(iframe, url) {
    if (!iframe || !url) return;
    var target = withAutoplay(url);
    var attempts = 0;
    function go() {
      if (navigated(iframe) || attempts >= 5 || !iframe.isConnected) return;
      attempts++;
      try {
        iframe.contentWindow.location.replace(target);
      } catch (e) { /* contentWindow not ready yet — retry below */ }
      setTimeout(go, 700);
    }
    // Give the fresh clone a tick so contentWindow exists before the first try.
    setTimeout(go, 80);
  }

  function onClickCapture(event) {
    var trigger = event.target && event.target.closest && event.target.closest('[data-video-trigger]');
    if (!trigger) return;
    var container = trigger.closest('.xo-embed-responsive') || trigger.closest('.xo-video') || trigger.closest('xo-video-custom');
    if (!container) return;

    // Capture the embed URL from the inert template BEFORE the shared handler
    // (bubble phase) clones it into the live DOM where the optimizer strips it.
    var url = null;
    var tpl = container.querySelector('kik-deferred-media template');
    if (tpl && tpl.content) {
      var tplIframe = tpl.content.querySelector('iframe');
      if (tplIframe) url = tplIframe.getAttribute('src') || tplIframe.getAttribute('data-src');
    }

    // After the shared handler has cloned + revealed the iframe, repair it if
    // the optimizer emptied its src.
    setTimeout(function () {
      var iframe = container.querySelector('iframe');
      if (iframe && !iframe.src) {
        navigateIframe(iframe, url || iframe.getAttribute('data-src'));
      }
    }, 50);
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('.centauri-c30-creator-videos');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (root.getAttribute('data-centauri-c30-video-rescue') === 'true') continue;
      root.setAttribute('data-centauri-c30-video-rescue', 'true');
      root.addEventListener('click', onClickCapture, true);
    }
  }

  window.__centauriC30VideoRescue = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init((event && event.target) || document); });
})();
